import router from './router'
import store from './store'
import global from './utils/global'
import { getToken, removeToken } from '@/utils/auth'
// import { setFirstPage, getFirstPage, delFirstPage } from '@/utils/cookie'
import {
  delWxCode,
  getSurveyCode,
  getWxCode,
  setRegSource
} from './utils/cookie'
import { addOauthPath } from './utils/base'
import Vue from 'vue'

const webAuthPageUri = 'https://open.weixin.qq.com/connect/qrconnect'
const clientAuthUri = 'https://open.weixin.qq.com/connect/oauth2/authorize'

const scope = 'snsapi_userinfo'
const responseType = 'code'

const whiteList = [
  'Redirect',
  'NewsIndex',
  'NewsDetail',
  'MeetingIndex',
  'MeetingDetail',
  'FormDetail',
  'TopicIndex',
  'TopicDetail',
  'ExpoIndex',
  'ExpoDetail',
  'EpDetail',
  'ExpoVote',
  'ExpoVoteSuccess',
  'SearchIndex',
  'MyIndex',
  'TopicTag',
  'MyAbout',
  '404',
  '403',
  'Register',
  'Register1',
  'WxNotice',
  'SurveyBefore',
  'SurveyDetail',
  'SurveySuccess',
  'AdminDownloadDetail',
  'ContactsDetail',
  'ActivityDetail',
  'UserDetail',
  'VideoIndex',
  'VideoDetail',
  'LuckyDetail',
  'LibraryDownload',
  'CardDetail',
  'CardDetailKey',
  'Term',
  'LibraryDetail',
  'LivePreview',
  'LiveDetail',
  'Logout',
  'MeetingSignRecord',
  'LinkDetail'
]

function redirectToLogin(to, from, next) {
  // console.log(addOauthPath(to.path, to.query))
  // console.log(encodeURIComponent(addOauthPath(to.path, to.query)))
  let loginPath = `/login?back=${encodeURIComponent(
    addOauthPath(to.path, to.query))}`
  if (to.name === 'SignDetail') {
    loginPath = `/login1?back=${encodeURIComponent(
      addOauthPath(to.path, to.query))}`
  }
  // console.log('loginPath:', loginPath)
  Vue.$vux.toast.show({
    text: '请先登录<br/>(系统自动跳转中)',
    type: 'warn',
    width: '9em',
    time: 500,
    onHide() {
      next(loginPath)
    }
  })
}

async function handleToLogin1(to, from, next) {
  if (to.query.code) {
    const wxFlag = store.getters.isWX ? '1' : '0'
    try {
      const rsp = await store.dispatch('GetWxUserInfo',
        { 'code': to.query.code, 'wx': wxFlag })
      if (rsp.message === 'ok') {
        next(`/login1?back=${to.query.back}`)
      } else {
        delWxCode()
        next(`/login1?type=sms&back=${to.query.back}`)
      }
    } catch (e) {
      this.$vux.toast.text('通过微信code获取token出错', 'top')
      delWxCode()
      next(`/login1?type=sms&back=${to.query.back}`)
    }
  } else if (getWxCode()) {
    next()
  } else {
    if ((!store.getters.isWX) ||
      (to.query.type && to.query.type === 'sms')) {
      next()
    } else {
      const redirectUri = global.domain + to.fullPath
      if (store.getters.isWX) {
        window.location.href = clientAuthUri +
          `?appid=${global.appid}&redirect_uri=${redirectUri}&response_type=${responseType}&scope=${scope}#wechat_redirect`
      } else {
        window.location.href = webAuthPageUri +
          `?appid=${global.openid}&redirect_uri=${redirectUri}&response_type=${responseType}&scope=snsapi_login#wechat_redirect`
      }
    }
  }
}

async function handleToLogin(to, from, next) {
  console.log('handleToLogin')
  if (to.query.code) {
    const wxFlag = store.getters.isWX ? '1' : '0'
    try {
      const rsp = await store.dispatch('GetWxUserInfo',
        { 'code': to.query.code, 'wx': wxFlag })
      if (rsp.message === 'ok') {
        next(`/login?back=${encodeURIComponent(to.query.back)}`)
      } else {
        delWxCode()
        next(`/login?type=sms&back=${encodeURIComponent(to.query.back)}`)
      }
    } catch (e) {
      this.$vux.toast.text('通过微信code获取token出错', 'top')
      delWxCode()
      next(`/login?type=sms&back=${encodeURIComponent(to.query.back)}`)
    }
  } else if (getWxCode()) {
    next()
  } else {
    if (!store.getters.isWX) {
      next()
    } else {
      const redirectUri = global.domain + to.fullPath
      if (store.getters.isWX && (!to.query.type || to.query.type !== 'sms')) {
        window.location.href = clientAuthUri +
          `?appid=${global.appid}&redirect_uri=${redirectUri}&response_type=${responseType}&scope=${scope}#wechat_redirect`
      } else {
        // next()
        window.location.href = webAuthPageUri +
          `?appid=${global.openid}&redirect_uri=${redirectUri}&response_type=${responseType}&scope=snsapi_login#wechat_redirect`
      }
    }
  }
}

function handleConfirmMobile(to, from, next) {
  if (to.name === 'ConfirmMobile' || to.name === 'MyMobileEdit') {
    next()
  } else {
    next(`/confirm_mobile?back=${to.fullPath}`)
  }
}

router.beforeEach(async(to, from, next) => {
  store.commit('UPDATE_LOADING_STATUS', { isLoading: true })

  if (store.getters.popupSetting === -1) {
    await store.dispatch('GetSetting')
  }

  // if (!store.getters.wxSignUrl) {
  //   store.dispatch('SetWxSignUrl', to.fullPath)
  // }

  // 百度统计使用
  if (to.path) window._hmt.push(['_trackPageview', to.fullPath])

  if (to.name === 'Login' && whiteList.includes(from.name)) {
    setRegSource(from.fullPath)
  }

  if (to.name === 'SurveyDetail') {
    if (getToken() || getSurveyCode()) {
      next()
    } else {
      next()
    }
  } else {
    // 没有token，无登录状态
    if (!getToken() || getToken() === undefined) {
      if (to.name === 'Login') {
        handleToLogin(to, from, next)
      } else if (to.name === 'Login1') {
        handleToLogin1(to, from, next)
      } else if (whiteList.indexOf(to.name) !== -1) {
        next()
      } else {
        redirectToLogin(to, from, next)
      }
    } else {
      // 有token的情况
      if (store.getters.user) { // 有user info的情况
        if (to.name === 'Login') {
          next(to.query.back || '/')
        } else if (to.name === 'Login1') {
          next(to.query.back || '/')
        } else if (!['Logout', '404', '403'].includes(to.name) &&
          store.getters.user.sms_verify_flag === 1) {
          handleConfirmMobile(to, from, next)
        } else {
          next()
        }
      } else {  // 有token，无user info的情况
        store.dispatch('GetUserInfo').then(res => {
          if (res.data.message === 'ok') {
            if (!['Logout', '404', '403'].includes(to.name) &&
              store.getters.user.sms_verify_flag === 1) {
              handleConfirmMobile(to, from, next)
            } else {
              if (to.name === 'Login') {
                let backUrl = decodeURIComponent(to.query.back)
                if (backUrl.startsWith('https://www.aibang.com')) {
                  backUrl += (backUrl.split('?')[1] ? '&' : '?') + 'ab360=' +
                    store.getters.token
                  location.href = backUrl
                } else {
                  next(decodeURIComponent(to.query.back) || '/')
                }
              } else if (to.name === 'Login1') {
                next(decodeURIComponent(to.query.back) || '/')
              } else {
                next()
              }
            }
          } else {
            if (whiteList.indexOf(to.name) !== -1) {
              removeToken()
              next()
            } else {
              store.dispatch('FedLogOut').then(() => {
                redirectToLogin(to, from, next)
              }).catch((e) => {
                console.log(e)
                removeToken()
                redirectToLogin(to, from, next)
              })
            }
          }
        }).catch(e => {
          console.log(e)
          if (whiteList.indexOf(to.name) !== -1) {
            if (e.response.status === 401) {
              removeToken()
            }
            next()
          } else {
            if (e.response.status === 401) {
              store.dispatch('FedLogOut').then(() => {
                redirectToLogin(to, from, next)
              }).catch((e) => {
                console.log(e)
                removeToken()
                redirectToLogin(to, from, next)
              })
            } else {
              removeToken()
              redirectToLogin(to, from, next)
            }
          }
        })
      }
    }
  }
})

router.afterEach(function(to, from) {
  store.commit('UPDATE_LOADING_STATUS', { isLoading: false })
})



// WEBPACK FOOTER //
// ./src/permission.js